import React from 'react'

import type { CSSObject } from '@emotion/react'
import { Box, withCitrusTheme } from '@gousto-internal/citrus-react'

import { MerchandisingHeader } from 'routes/Menu/MenuRecipesPage/CollectionHeader/CollectionHeaderWrapper/MerchandisingHeader'
import { AccountOnHoldAlert } from 'routes/Menu/components/AccountOnHold/AccountOnHoldAlert'
import { FlexOrderAlert } from 'routes/Menu/components/Flex/FlexOrderAlert'
import type { MenuHeadersIncludesData } from 'routes/Menu/domains/brand/types'

type CollectionHeaderProps = {
  showAccountOnHoldAlert: boolean
  isFlexOrder: boolean
  showMerchandisingBanner: boolean
  merchandisingHeader?: MenuHeadersIncludesData | null
}

const CustomBox = withCitrusTheme(Box, () => ({
  marginTop: '0',
  marginBottom: '0',
}))

const CollectionBox = withCitrusTheme(Box, (theme) => ({
  marginTop: '-3rem',
  paddingBottom: theme.spacing(12),
  ...(theme.responsiveStyle([0, 0, -30, -30], ['marginLeft', 'marginRight']) as CSSObject),
}))

export const CollectionHeader = ({
  showAccountOnHoldAlert,
  isFlexOrder,
  showMerchandisingBanner,
  merchandisingHeader,
}: CollectionHeaderProps) => {
  if (showAccountOnHoldAlert) {
    return (
      <CustomBox>
        <AccountOnHoldAlert />
      </CustomBox>
    )
  }

  if (isFlexOrder) {
    return (
      <CustomBox>
        <FlexOrderAlert />
      </CustomBox>
    )
  }

  if (showMerchandisingBanner) {
    return (
      <CollectionBox>
        <MerchandisingHeader header={merchandisingHeader} />
      </CollectionBox>
    )
  }

  return null
}
